import { lazy, Suspense } from "react";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import SEOHead from "@/components/seo/SEOHead";
import LazySection from "@/components/ui/LazySection";

// Lazy-load below-fold sections to reduce initial JS bundle & TBT
const VideoSection = lazy(() => import("@/components/home/VideoSection"));
const HealthBenefits = lazy(() => import("@/components/home/HealthBenefits"));
const BlogHighlights = lazy(() => import("@/components/home/BlogHighlights"));
const ClientGallery = lazy(() => import("@/components/home/ClientGallery"));
const ContactStrip = lazy(() => import("@/components/home/ContactStrip"));

const homeFaqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is a water ionizer and how does it work?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A water ionizer uses electrolysis to separate water into alkaline and acidic streams. The alkaline water is rich in molecular hydrogen and antioxidants, offering health benefits like better hydration, pH balance, and detoxification. PurePro India offers premium water ionizers made in the USA.",
      },
    },
    {
      "@type": "Question",
      name: "Which is the best water ionizer in India?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "PurePro JA-703 is the best-selling water ionizer in India with 7 platinum-titanium plates, producing water up to pH 11.0+. It offers the highest ORP (up to -700mV) and is comparable to Kangen water systems at a more affordable price.",
      },
    },
    {
      "@type": "Question",
      name: "What is the price of a water ionizer in India?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Water ionizer prices in India range from ₹95,000 for entry-level models (PurePro JA-103) to ₹1,85,000 for flagship models (JA-2000). PurePro also offers Nihon Trim medical-grade ionizers from Japan.",
      },
    },
    {
      "@type": "Question",
      name: "Does PurePro India offer RO water purifiers?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, PurePro India offers a complete range of RO water purifiers including domestic RO systems (ERS series), Perfect Water RO+Ionizer combos (PJ series), and commercial/industrial RO plants. All systems are made in USA with international certifications.",
      },
    },
  ],
};

const Index = () => {
  return (
    <Layout>
      <SEOHead
        title="Best Water Ionizer & RO Systems India"
        description="Buy best water ionizer in India from PurePro. Premium alkaline water machines, RO systems & hydrogen water products. Made in USA. Free demo & pan-India service."
        path="/"
        keywords="water ionizer India, best water ionizer India, alkaline water machine India, RO systems India, hydrogen water bottle India, PurePro India"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "PurePro India",
            alternateName: "Pure Pro Water Corporation India",
            url: "https://www.pureproindia.in",
            logo: "https://www.pureproindia.in/images/hero-banner.jpg",
            description: "India's leading supplier of premium water ionizers, alkaline water machines, RO systems, and hydrogen water products. Made in USA with 20+ years of expertise.",
            telephone: "+91-9711808331",
            email: "info@pureproindia.in",
            address: {
              "@type": "PostalAddress",
              streetAddress: "1/6786, East Rohtas Nagar",
              addressLocality: "Delhi",
              addressRegion: "DL",
              postalCode: "110032",
              addressCountry: "IN",
            },
            sameAs: [
              "https://www.facebook.com/pureproindia",
              "https://www.instagram.com/pureproindia",
              "https://www.youtube.com/@pureproindia",
            ],
            areaServed: {
              "@type": "Country",
              name: "India",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "PurePro India",
            url: "https://www.pureproindia.in",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.pureproindia.in/products?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          homeFaqJsonLd,
        ]}
      />
      <HeroSection />
      <FeaturedProducts />

      {/* Below-fold sections: lazy loaded on viewport approach */}
      <LazySection minHeight="300px">
        <Suspense fallback={null}>
          <VideoSection />
        </Suspense>
      </LazySection>

      <LazySection minHeight="400px">
        <Suspense fallback={null}>
          <HealthBenefits />
        </Suspense>
      </LazySection>

      <LazySection minHeight="300px">
        <Suspense fallback={null}>
          <BlogHighlights />
        </Suspense>
      </LazySection>

      <LazySection minHeight="200px">
        <Suspense fallback={null}>
          <ClientGallery />
        </Suspense>
      </LazySection>

      <LazySection minHeight="100px">
        <Suspense fallback={null}>
          <ContactStrip />
        </Suspense>
      </LazySection>
    </Layout>
  );
};

export default Index;
